import React from "react";
import EmotionLine from "./emotionline";
import "./emotionlist.css";

class EmotionList extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {
            list: this.prepareList(props.list)
        };

        this.handleLineChange = this.handleLineChange.bind(this);
        this.handleLineDelete = this.handleLineDelete.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
    }


    createDefaultLine()
    {
        return {
            emotion:
                this.props.defaultEmotion == null
                    ? "NEUTRAL"
                    : this.props.defaultEmotion,

            source:
                this.props.defaultSource || "HUMAN",

            confidence:
                this.props.defaultConfidence == null
                    ? 1
                    : this.props.defaultConfidence,

            intensity:
                this.props.defaultIntensity == null
                    ? 0
                    : this.props.defaultIntensity,

            sentiment:
                this.props.defaultSentiment == null
                    ? 0
                    : this.props.defaultSentiment
        };
    }


    prepareList(list)
    {
        let result = Array.isArray(list)
            ? [...list]
            : [];

        /*
         * Aucune ligne :
         * on crée une ligne par défaut.
         */
        if (result.length === 0)
        {
            result.push(
                this.createDefaultLine()
            );
        }

        /*
         * Respect de maxLines.
         */
        if (this.props.maxLines != null)
        {
            result = result.slice(
                0,
                this.props.maxLines
            );
        }

        return result;
    }


    componentDidUpdate(prevProps)
    {
        if (prevProps.list !== this.props.list)
        {
            this.setState({
                list: this.prepareList(
                    this.props.list
                )
            });
        }
    }


    notifyChange(list)
    {
        if (this.props.onChange)
            this.props.onChange(list);
    }


    handleLineChange(index, item)
    {
        const list = [...this.state.list];

        list[index] = item;

        this.setState({
            list: list
        });

        this.notifyChange(list);
    }


    handleLineDelete(index)
    {
        let list = [...this.state.list];

        list.splice(index, 1);

        /*
         * Si la dernière ligne est supprimée,
         * on recrée une ligne par défaut.
         */
        if (list.length === 0)
        {
            list.push(
                this.createDefaultLine()
            );
        }

        this.setState({
            list: list
        });

        this.notifyChange(list);
    }


    handleAdd()
    {
        if (
            this.props.maxLines != null &&
            this.state.list.length >=
                this.props.maxLines
        )
        {
            return;
        }

        const list = [
            ...this.state.list,
            this.createDefaultLine()
        ];

        this.setState({
            list: list
        });

        this.notifyChange(list);
    }


    render()
    {
        const list = this.state.list;

        return (
            <div className="emotion-list">

                <div className="emotion-list-header">

                    {/* espace image */}
                    <div className="emotion-header-image">
                    </div>

                    <div className="emotion-header-emotion">
                        Emotion
                    </div>

                    <div className="emotion-header-intensity">
                        Intens.
                    </div>

                    <div className="emotion-header-sentiment">
                        Sent.
                    </div>

                    <div className="emotion-header-confidence">
                        Conf.
                    </div>

                    {/* espace bouton suppression */}
                    <div className="emotion-header-delete">
                    </div>

                </div>
                
                {list.map((item, index) => (
                    <div className="emotion-list-body">
                    <EmotionLine
                        key={index}

                        item={item}

                        emotionsList={
                            this.props.emotionsList
                        }

                        imgIA={this.props.imgIA}
                        imgHuman={this.props.imgHuman}

                        intensityLimit={
                            this.props.intensityLimit
                        }

                        sentimentLimit={
                            this.props.sentimentLimit
                        }

                        onChange={(newItem) =>
                            this.handleLineChange(
                                index,
                                newItem
                            )
                        }

                        onDelete={() =>
                            this.handleLineDelete(
                                index
                            )
                        }
                    />
                    </div>
                ))}
                


                {(
                    this.props.maxLines == null ||
                    list.length <
                        this.props.maxLines
                ) && (
                    <button
                        type="button"
                        className="emotion-list-add"
                        onClick={this.handleAdd}
                    >
                        +
                    </button>
                )}

            </div>
        );
    }
}


EmotionList.defaultProps = {
    list: [],
    maxLines: 3,

    defaultEmotion: 0,
    defaultSource: "HUMAN",
    defaultConfidence: 1,
    defaultIntensity: 0,
    defaultSentiment: 0,

    intensityLimit: {
        min: -0.5,
        max: 0.5
    },

    sentimentLimit: {
        min: -0.5,
        max: 0.5
    }
};


export default EmotionList;